'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.listResourcesFromSchemaFactory = exports.isObject = undefined;

var _isNotGraphqlPrivateType = require('./isNotGraphqlPrivateType');

var _isNotGraphqlPrivateType2 = _interopRequireDefault(_isNotGraphqlPrivateType);

var _filterWithIncludeExclude = require('./filterWithIncludeExclude');

var _filterWithIncludeExclude2 = _interopRequireDefault(_filterWithIncludeExclude);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isObject = exports.isObject = function isObject(type) {
    return type.kind === 'OBJECT';
};

var listResourcesFromSchemaFactory = exports.listResourcesFromSchemaFactory = function listResourcesFromSchemaFactory(filterWithIncludeExcludeImpl) {
    return function (_ref) {
        var types = _ref.types;

        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            includeTypes = _ref2.includeTypes,
            excludeTypes = _ref2.excludeTypes;

        return types.filter(_isNotGraphqlPrivateType2.default).filter(filterWithIncludeExcludeImpl({
            include: includeTypes,
            exclude: excludeTypes
        })).filter(isObject).map(function (type) {
            return type;
        });
    };
};

exports.default = listResourcesFromSchemaFactory(_filterWithIncludeExclude2.default);


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/listResourcesFromSchema.js
// module id = 938
// module chunks = 0